import type { AvatarProps } from 'stream-chat-react';
import { Avatar, MessageStatus } from 'stream-chat-react';

import { useConversationContext } from './conversationProvider';

const StoreAvatar = (props: AvatarProps) => {
  const { store } = useConversationContext();

  return <Avatar {...props} image={store.photo} name={store.name} />;
};

/**
 * Stream's default read-receipt UI, relabelled as the store.
 *
 * `MessageStatus` renders only on the shopper's own messages, and its avatar is
 * whoever *else* has read them — always a store manager, since the connected
 * user is filtered out of `readBy`. Those Stream users carry no `name`, so the
 * default UI falls back to `user.id` and renders the first character of a raw
 * UUID.
 *
 * `readBy` is not a prop, so the identity cannot be patched the way
 * [CustomMessage] patches `message.user`. `Avatar` and `tooltipUserNameMapper`
 * are props, though, so we can relabel the reader while leaving every bit of
 * Stream's markup — and the delivered/sending checkmarks — untouched.
 * @see https://getstream.io/chat/docs/sdk/react/v11/components/message-components/message-ui/
 */
export const CustomMessageStatus = () => {
  const { store } = useConversationContext();

  return (
    <MessageStatus
      Avatar={StoreAvatar}
      tooltipUserNameMapper={() => store.name}
    />
  );
};
